import {AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {of} from 'rxjs';
import {mergeAll} from 'rxjs/operators';
import {AppState, LocalStorageService, routeAnimations, selectAuthIsLoading, selectAuthPersonaId}
  from '../../../core/core.module';
import {ConfigService} from '../../../shared';
import {AUTH_EMITTED_IN, AUTH_EXPIRES_IN, AUTH_ROLE_ID, Rol, Role} from '../../../core';
import {Persona} from '../../../chacra-core';
import {LoadDataService} from '../../services/load-data.service';
import {selectFeaturesIsLoading} from '../../store/features.selectors';
import {PersonasRegistrerRedirectAction} from '../../store/entities/shared/personas/personas.actions';
import {selectPersonaById} from '../../store/entities/shared/personas/personas.selectors';
import {selectAllRoles} from '../../store/entities/shared/roles/roles.selectors';
import {FeaturesService} from '../../services/features.services';
import {NavigationEnd, Router} from "@angular/router";
import {MensajesService} from "../../services/mensajes.service";
import moment from 'moment';

const packageJson = require('../../../../../package.json');


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  animations: [routeAnimations],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MainComponent implements OnInit, AfterContentChecked {
  title = 'Seguros Visor';
  envName = '';
  version = packageJson.version;
  year = new Date().getFullYear();
  logo = 'assets/logo.png';
  navigation = [];
  navigationSideMenu = [...this.navigation];

  personaId: string = null;
  persona: Persona = null;
  rolId: string = null;
  role: Role = null;

  isLoading: boolean;
  newMessages: number = 0;
  clock = '--:--';
  expiresTimeLeft = 0;

  constructor(private store: Store<AppState>,
              private storageService: LocalStorageService,
              private loadDataService: LoadDataService,
              private cdref: ChangeDetectorRef,
              private router: Router,
              private mensajesService: MensajesService,
              private featuresService: FeaturesService) {
    this.envName = ConfigService.get('envName');
  }

  ngOnInit(): void {
    this.storageService.testLocalStorage();

    this.store.pipe(select(selectAuthPersonaId)).subscribe(
      (personaId: string) => {
        this.personaId = personaId;
        if (this.personaId) {

          const rolId = this.putRoleId();
          if (rolId) {
            this.loadUserData();
            this.getTimeExpires();

            this.navigation = [
              {link: '/features/chacras', label: 'Chacras', current: false},
            ];

            switch (rolId) {
              case Rol.AGLUTINADORA: case Rol.ASEGURADORA:
                this.navigation = [
                  ...this.navigation,
                  {link: '/features/empresas', label: 'Empresas', current: false},
                ];
                break;
            }

            this.navigation = [
              ...this.navigation,
              {link: '/features/mapa', label: 'Mapa', current: false},
              // {link: '/features/mensajes', label: 'Mensajes', current: false, separator: true},
            ];

            this.navigationSideMenu = [...this.navigation];
          }

          this.store.pipe(select(selectPersonaById(this.personaId)))
            .subscribe(persona => {
              this.persona = persona;
              this.putRoleId();
            });

        } else {
          this.persona = null;
        }
      });

    this.store.pipe(select(selectAllRoles)).subscribe(
      (roles: Role[]) => {
        this.role = roles.find(r => r.rolId == this.rolId);
      });

    of(this.store.select(selectAuthIsLoading), this.store.select(selectFeaturesIsLoading))
      .pipe(mergeAll())
      .subscribe((isLoading: boolean) => {
        this.isLoading = isLoading;
      });

    this.router.events.subscribe((event: NavigationEnd | null) => {
      if(event instanceof NavigationEnd){
        this.navigation = this.navigation.map(nav => {
          nav.current = false;
          if(event.url.includes(nav.link))
            nav.current = true;
          return nav;
        });
      }
    });

    this.mensajesService.watchNewMessage().subscribe(cant => {
      this.navigation = this.navigation.map(nav => {
        if(nav.label.includes('Mensajes')){
          let label = 'Mensajes';
          if(cant>0)
            label = `Mensajes (${cant})`;
          nav.label = label;
        }
        return nav;
      });
    });
  }

  getTimeExpires(){
    const emitted = parseInt(this.storageService.getItem(AUTH_EMITTED_IN));
    const expires = parseInt(this.storageService.getItem(AUTH_EXPIRES_IN));
    let time = parseInt(moment(new Date()).format('x'));
    time = expires - Math.round((time - emitted)/1000);
    if(time && !isNaN(time)){
      this.expiresTimeLeft = time;
      const me = this;
      setInterval(function(){
        me.adjustClock(me.expiresTimeLeft);
        me.expiresTimeLeft--;
      }, 1000);
    }
  }

  adjustClock(time){
    if(time >= 0){
      let m = Math.floor(time/60);
      let s = time%60;
      let h = Math.floor(m/60);
      m = m%60;
      let t = `${m < 10 ? '0'+m : m}:${s < 10 ? '0'+s : s}`;
      if(h > 0){
        t = `${h < 10 ? '0'+h : h}:${t}`;
      }
      this.clock = t;
    }
    else{
      this.clock = '--:--';
    }
  }

  onLogoutClick() {
    this.featuresService.logout();
  }

  onProfileClick() {
    this.store.dispatch(new PersonasRegistrerRedirectAction());
  }

  loadUserData() {
    this.loadDataService.load();
  }

  putRoleId() {
    const rolId = this.storageService.getItem(AUTH_ROLE_ID);
    if (rolId) {
      this.rolId = rolId;
    }
    return rolId;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}

